export const toPgTextArray = (input: string[]): string => {
  return `{${input.map((el: string) => `"${el.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`).join(",")}}`;
};
